export default __webpack_public_path__ + "static/media/github-icon.c48bfb2a.svg";